import { render, staticRenderFns } from "./AvailmentProc.vue?vue&type=template&id=d5d4dbec&scoped=true"
import script from "./AvailmentProc.vue?vue&type=script&lang=js"
export * from "./AvailmentProc.vue?vue&type=script&lang=js"
import style0 from "./AvailmentProc.vue?vue&type=style&index=0&id=d5d4dbec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d4dbec",
  null
  
)

export default component.exports